import { Separator } from "@/components/ui/Separator";
import { BodyText } from "@/components/ui/Text";
import { format, isToday, isYesterday } from "date-fns";
import { Calendar } from "lucide-react";
import { memo } from "react";

interface DateSeparatorProps {
  date: string | Date;
}

export const DateSeparator = memo(({ date }: DateSeparatorProps) => {
  const dateObj = typeof date === "string" ? new Date(date) : date;

  // Format the date based on whether it's today, yesterday, or another day
  let formattedDate: string;
  if (isToday(dateObj)) {
    formattedDate = "Today";
  } else if (isYesterday(dateObj)) {
    formattedDate = "Yesterday";
  } else {
    formattedDate = format(dateObj, "MMMM d, yyyy");
  }

  return (
    <div className="flex items-center justify-center my-6 w-full">
      <Separator className="flex-grow" />
      <div className="mx-4 text-sm flex items-center">
        <Calendar size={16} className="mr-2 text-tertiary" />
        <BodyText size="sm" textColor="tertiary">
          {formattedDate}
        </BodyText>
      </div>
      <Separator className="flex-grow" />
    </div>
  );
});
